import { useState, useEffect } from 'react'
import Bet from "../components/Bet"
import { db, increment } from '../firebase'
import { useAuth } from "../contexts/AuthContext"
import '../css/Base.css'
import ConnectionToast from "../components/ConnectionToast"

function Bets() {

    const [isLoading, setIsLoading] = useState(true);
    const [loadedData, setLoadedData] = useState([]);
    const { currentUser } = useAuth()

    useEffect(() => {
        setIsLoading(true);

        var arrayData = []
        var docRef1 = db.collection("Players").doc(`${currentUser.uid}`).collection("Bets")

        var counterBETS = 0;
        var processedBets = 0;

        // to get all the bets
        docRef1.get().then((querySnapshot) => {
            counterBETS = querySnapshot.size;

            querySnapshot.forEach((doc) => {

                arrayData.push(doc.data())
                processedBets++

                if (processedBets === counterBETS) {
                    setLoadedData(arrayData)
                    setIsLoading(false)
                }
            });
        });


        var fixturesNotProcessed = [];
        var counter = 0;

        var today = new Date();
        var dd = String(today.getDate());
        var mm = String(today.getMonth() + 1); //January is 0!
        var yyyy = today.getFullYear();
        today = `${yyyy}-${mm}-${dd}`

        checkFixturesForProcessed();

        function checkFixturesForProcessed() {
            var query = db.collection("Fixtures")
            query = query.where("isProcessed", "==", false)
            query = query.where("date", "<=", today)

            query.get().then((fixtures => {
                fixtures.forEach((fixture => {
                    fixturesNotProcessed.push(fixture.data().id)
                    counter++
                }))

                if (fixtures.size === counter && fixtures.size !== 0) {

                    var counterBets = 0;
                    var counterFavorites = 0;

                    var counterProcessedFixtures = 0;
                    var counterProcessedBets = 0;
                    var counterProcessedFavorites = 0;

                    fixturesNotProcessed.forEach((id => {
                        fetch(`https://soccer.sportmonks.com/api/v2.0/fixtures/${id}?api_token=oAF3XOevLeC24Zjuzvu56vfOfvyrmHSd11eHr4Ij6ifeJq563NzHeKFrLaJy`
                        )
                            .then((response => {
                                return response.json();
                            }))
                            .then((response => {

                                db.collection("Players").get().then((players => {
                                    players.forEach((player => {
                                        db.collection("Players").doc(`${player.id}`).collection("Bets").doc(`${id}`)
                                            .get().then((doc => {
                                                if (doc.exists) {
                                                    counterBets++
                                                }
                                            }))
                                        db.collection("Players").doc(`${player.id}`).collection("Favorites").doc(`${id}`)
                                            .get().then((doc => {
                                                if (doc.exists) {
                                                    counterFavorites++
                                                }
                                            }))
                                    }))
                                })).then(() => {
                                    if (response.data.time.status === "FT") {

                                        db.collection("Fixtures").doc(`${id}`).set(
                                            {
                                                winnerTeamId: response.data.winner_team_id,
                                                isProcessed: true,
                                                score: response.data.scores.ft_score
                                            },
                                            {
                                                merge: true
                                            }
                                        ).then((e => {
                                            counterProcessedFixtures++


                                            console.log(`${counterProcessedFixtures} ? ${counter}`)
                                            console.log(`${counterProcessedBets} ? ${counterBets}`)
                                            console.log(`${counterProcessedFavorites} ? ${counterFavorites}`)

                                            if (counterProcessedFixtures === counter && counterProcessedBets === counterBets && counterProcessedFavorites === counterFavorites) {
                                                checkBetsToUpdateScore()
                                            }
                                        }))

                                        db.collection("Players").get().then((playersId => {
                                            playersId.forEach((player => {

                                                // set data in BETS
                                                db.collection("Players").doc(`${player.id}`).collection("Bets").doc(`${id}`)
                                                    .get()
                                                    .then((bet => {
                                                        if (bet.exists) {

                                                            db.collection("Players").doc(`${player.id}`).collection("Bets").doc(`${id}`)
                                                                .set({
                                                                    winnerTeamId: response.data.winner_team_id,
                                                                    isProcessed: true,
                                                                    score: response.data.scores.ft_score
                                                                },
                                                                    {
                                                                        merge: true
                                                                    }
                                                                ).then((e => {
                                                                    counterProcessedBets++

                                                                    console.log(`${counterProcessedFixtures} ? ${counter}`)
                                                                    console.log(`${counterProcessedBets} ? ${counterBets}`)
                                                                    console.log(`${counterProcessedFavorites} ? ${counterFavorites}`)

                                                                    if (counterProcessedFixtures === counter && counterProcessedBets === counterBets && counterProcessedFavorites === counterFavorites) {
                                                                        checkBetsToUpdateScore()
                                                                    }
                                                                }))
                                                        }
                                                    }))




                                                // set data in FAVO 
                                                db.collection("Players").doc(`${player.id}`).collection("Favorites").doc(`${id}`)
                                                    .get().then((doc => {
                                                        if (doc.exists) {
                                                            db.collection("Players").doc(`${player.id}`).collection("Favorites").doc(`${id}`)
                                                                .set({
                                                                    winnerTeamId: response.data.winner_team_id,
                                                                    isProcessed: true,
                                                                    score: response.data.scores.ft_score
                                                                },
                                                                    {
                                                                        merge: true
                                                                    }
                                                                ).then((e => {
                                                                    counterProcessedFavorites++

                                                                    console.log(`${counterProcessedFixtures} ? ${counter}`)
                                                                    console.log(`${counterProcessedBets} ? ${counterBets}`)
                                                                    console.log(`${counterProcessedFavorites} ? ${counterFavorites}`)

                                                                    if (counterProcessedFixtures === counter && counterProcessedBets === counterBets && counterProcessedFavorites === counterFavorites) {
                                                                        checkBetsToUpdateScore()
                                                                    }
                                                                }))
                                                        }
                                                    }))
                                            }))
                                        }))
                                    }
                                })
                            }))
                    })
                    )
                }
            }))
        }

        function checkBetsToUpdateScore() {

            var arrayWithProcessedFixtureIds = [];

            var query2 = db.collection("Fixtures")
            query2 = query2.where("isProcessed", "==", true)

            var inTenDays = new Date();

            inTenDays.setDate(inTenDays.getDate() + 10);

            var ddT = inTenDays.getDate();
            var mmT = inTenDays.getMonth() + 1;
            var y = inTenDays.getFullYear();

            inTenDays = y + '-' + mmT + '-' + ddT;
            var inTenDaysString = inTenDays.toString();

            query2 = query2.where("date", "<=", inTenDaysString)
            query2.get().then((querysnapshot => {
                var counter = querysnapshot.size;
                var processed = 0;

                querysnapshot.forEach((doc => {

                    arrayWithProcessedFixtureIds.push(doc.data().id)
                    processed++

                    if (processed === counter) {

                        db.collection("Players").get().then((querysnapshot => {
                            querysnapshot.forEach((playerIdDoc => {

                                db.collection("Players").doc(`${playerIdDoc.id}`).collection("Bets").get().then((fixtureId => {
                                    fixtureId.forEach((doc => {
                                        if (doc.exists) {

                                            if (arrayWithProcessedFixtureIds.includes(doc.data().id)) {

                                                db.collection("Players").doc(`${playerIdDoc.id}`).collection("Bets").doc(`${doc.id}`).get().then((doc => {

                                                    if (doc.data().scoreIsAdded === false) {

                                                        // player bet was correct 
                                                        if (doc.data().winnerTeamId === doc.data().bet) {
                                                            db.collection("Players").doc(`${playerIdDoc.id}`).update({
                                                                betsWon: increment
                                                            }).then(() => {
                                                                db.collection("Players").doc(`${playerIdDoc.id}`).update({
                                                                    totalBets: increment
                                                                })
                                                            })
                                                        }
                                                        // player bet was incorrect
                                                        else {
                                                            db.collection("Players").doc(`${playerIdDoc.id}`).update({
                                                                betsLost: increment
                                                            }).then(() => {
                                                                db.collection("Players").doc(`${playerIdDoc.id}`).update({
                                                                    totalBets: increment
                                                                })
                                                            })
                                                        }

                                                    }
                                                    else {
                                                        console.log("scoreisAdded = true, so I do nothing")
                                                    }

                                                })).then(() => {
                                                    db.collection("Players").doc(`${playerIdDoc.id}`).get().then((i => {
                                                        db.collection("Players").doc(`${playerIdDoc.id}`).update({
                                                            winPercentage: Math.round((i.data().betsWon / (i.data().betsWon + i.data().betsLost) * 100))
                                                        })
                                                    }))
                                                })
                                            }
                                        }
                                    }))
                                }))
                            }))
                        }))
                    }

                }))

            }))


        }

        // OFFLINE ONLINE TOAST
        let connectionLostToast = document.getElementById('connectionLost')
        connectionLostToast.setAttribute('autohide', false)

        window.addEventListener('offline', function () {
            connectionLostToast.style.display = "block"
        });

        window.addEventListener('online', function () {
            connectionLostToast.style.display = "none"
        });


    }, [currentUser.uid])


    //if we are loading the data return loading .. 
    if (isLoading && loadedData.length === 0) {
        return (
            <>
                <div className="centered">
                    <p className="text-light text-center">NO BETS YET</p>
                </div>
                <ConnectionToast />
            </>
        )
    }

    //if we are loading the data return loading .. 
    if (isLoading) {
        return (
            <>
                <div className="lds-circle" />
                <ConnectionToast />
            </>
        )
    }

    return (
        <div className='cntr'>
            <ConnectionToast />
            <div className="row g-0 justify-content-md-end rowwithmargin pt-5">
                <h1 className="col-md-10 mb-3 font-link-header2">
                    YOUR. BETS. ({loadedData.length})
                </h1>
                {loadedData.map((data) => {
                    return (
                        <div key={data.id} className="col-md-9 col-sm-1 mb-4">
                            <Bet
                                id={data.id}
                                teams={data.teams}
                                dateAndTime={data.dateAndTime}
                                league={data.league}
                                logoLocalTeam={data.logoLocalTeam}
                                logoVisitorTeam={data.logoVisitorTeam}
                                localTeamId={data.localTeamId}
                                visitorTeamId={data.visitorTeamId}
                                predictionLocal={data.predictionLocal}
                                predictionVisitor={data.predictionVisitor}
                                predictionDraw={data.predictionDraw}
                                betDrawOrTeam={data.betDrawOrTeam}
                                bet={data.bet}
                                timestamp={data.timestamp}
                                date={data.date}
                                time={data.time}
                                bettedTimestamp={data.bettedTimestamp}
                                winnerTeamId={data.winnerTeamId}
                                isProcessed={data.isProcessed}
                                scoreIsAdded={data.scoreIsAdded}
                                score={data.score}>
                            </Bet>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Bets